import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import FlipTextV2 from "components/elements/flipTextV2"
import Image from "components/elements/image"
import RichText from "components/elements/richText"
import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React from "react"
import "./split-section-v2.scss"

const SplitSectionV2 = ({
  callsToAction,
  content,
  contentOrientation,
  heading,
  image,
  subTitle,
}) => {
  const appliedContentOrientation =
    contentOrientation === "Image on the Left and Content on the Right"
      ? "image-left"
      : "image-right"
  return (
    <section
      className={`split-section-v2 split-section-v2--content-orientation-${appliedContentOrientation}`}
    >
      {heading && (
        <div className="container-v2 split-section-v2--header-wrapper">
          {heading && (
            <h2 className="split-section-v2--header-title">
              {heading && (
                <span className="split-section-v2--header-title-main">
                  <TextLockupV2>{heading}</TextLockupV2>
                </span>
              )}
              {` `}
              {/* if there's an array length greater than 1, then we need to render the FlipTextV2 component   */}
              {Array.isArray(subTitle) && subTitle?.length > 1 && (
                <span className="split-section-v2--header-rotate">
                  <FlipTextV2 text={subTitle} />
                </span>
              )}
              {/* if there's an array length equal to 1, then we need to render the FlipTextV2 component */}
              {Array.isArray(subTitle) && subTitle?.length === 1 && (
                <span className="split-section-v2--header-rotate">
                  <TextLockupV2>{subTitle[0]}</TextLockupV2>
                </span>
              )}
            </h2>
          )}
        </div>
      )}
      <div className="container-v2">
        {image && image.fluid && (
          <div className="split-section-v2--image">
            <Image alt={heading} className="" image={image.fluid} />
          </div>
        )}
        <div className="split-section-v2--content">
          {content && content?.json && (
            <RichText className="" richText={content} textStyle="full" />
          )}
          {callsToAction && callsToAction?.length > 0 && (
            <div className="split-section-v2--calls-to-action">
              {callsToAction.map(callToAction => (
                <p
                  className="split-section-v2--calls-to-action-button"
                  key={callToAction.id}
                >
                  <ButtonV2
                    accessibilityLabel={callToAction.accessibilityLabel}
                    className={getButtonClasses(
                      callToAction.buttonStyle,
                      callToAction.buttonSize
                    )}
                    href={callToAction.path}
                    key={callToAction.id}
                    showArrow={callToAction.showArrow === "Yes" ? true : false}
                    text={callToAction.text}
                  />
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
SplitSectionV2.propTypes = {
  callsToAction: PropTypes.array.isRequired,
  content: PropTypes.object.isRequired,
  contentOrientation: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
}

export default SplitSectionV2
